import React from 'react';
import injectSheet, { type Styles } from 'react-jss';
import AppSettings from '../../app-settings';

type SiteHeaderClassNames = 'siteHeader' | 'siteHeaderLogo';

const styles: Styles<SiteHeaderClassNames, SiteHeaderProps> = {
  siteHeader: {
    padding: '18vh 0 6vh',
  },
  siteHeaderLogo: {
    width: 230,
    margin: 'auto',
    display: 'block',
  },
};

interface SiteHeaderProps {
  classes: Record<SiteHeaderClassNames, string>;
  showLink: boolean;
}

class SiteHeader extends React.Component<SiteHeaderProps> {
  marketingWebsiteHomeUrl = AppSettings.MARKETING_URL;

  render() {
    const { classes } = this.props;
    let img = <img src="/assets/spoiler-alert-logo.svg" alt="Spoiler Alert" className={classes.siteHeaderLogo} />;
    if (this.props.showLink) {
      img = (
        <a href={this.marketingWebsiteHomeUrl}>
          <img src="/assets/spoiler-alert-logo.svg" alt="Spoiler Alert" className={classes.siteHeaderLogo} />
        </a>
      );
    }

    return <div className={classes.siteHeader}>{img}</div>;
  }
}

export default injectSheet(styles)(SiteHeader);
